'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.backgroundJazz = twentyninetimes.backgroundJazz || function () {

	function init() {
		backgroundMask();
	}

    function backgroundMask(){

        
        const cldiv = document.createElement("div");
        cldiv.setAttribute('class', 'cropped-lines');
        document.body.appendChild(cldiv);

        document.body.addEventListener('mousemove', function(e) {
            cldiv.style.setProperty('--clip-position', `${(e.clientX - 100)}px ${(e.clientY - 100)}px`);
        });

    }

    return {
		init : init
	};

}();
